import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { LicenseProps } from '../../../types/IdProps';
import AddLicenseAttachmentPopup from '../Popups/License_popup_AddAttachment';

const License_tab_Attachments: React.FC<LicenseProps> = ({ licenseId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForAttachmentType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [licenseId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/LicenseAttachments/ByLicense/' + licenseId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/LicenseAttachments/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function canDeleteRow(row): boolean {
        if (row.attachmentType.canDelete && isAuthorizedForAttachmentType(ApplicationFunctions.DeleteAttachment, row.attachmentTypeId))
            return true

        return false;
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'attachmentId', visible: false },
        { dataProp: 'thumbnailUrl', dataType: 'image', sort: false},
        { title: 'Type', dataProp: 'attachmentType.name' },
        { title: 'Name', dataProp: 'attachmentName', sort: 'asc' },
        { title: 'Version', dataProp: 'latestVersion', dataType: 'number', width: 100 },
        { title: 'Created on', dataProp: 'createdOn', dataType: 'datetime' },
        { title: 'Created by', dataProp: 'createdByUser', dataType: 'user' }
    ];

    if (isAuthorizedForAttachmentType(ApplicationFunctions.CreateAttachment) || isAuthorizedForAttachmentType(ApplicationFunctions.DeleteAttachment)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, isVisible: canDeleteRow }]
            }
        );
    }

    return (
        <>
            {data && (
                <DataTable
                    name='dtLicenseAttachments'
                    colInfos={colInfos}
                    tableData={data}
                    navigateTitle='Attachment'
                    navigateUrl='/plm/Common/Attachment/'
                />
            )}
            {showPopup && <AddLicenseAttachmentPopup licenseId={licenseId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default License_tab_Attachments;